import React from 'react'
import LgbtDecorLineSingle from '../LgbtDecorLineSingle/LgbtDecorLineSingle'

import styles from './LinedDecorTitleWhite.module.scss'

function LinedDecorTitleWhite(props) {
    const DynamicTag = props.tag || 'h2'
    return (
        <div className={styles.title}>
            <LgbtDecorLineSingle color='white' />
            <DynamicTag>{props.children}</DynamicTag>
            <LgbtDecorLineSingle color='white' />
        </div>
    )
}

export default LinedDecorTitleWhite